import _get from "lodash/get";
import styled, { css } from 'styled-components';
import { rem } from 'polished';
import headerTheme from '../../styles/headerTheme';
var HeaderOffsetContainer = styled.div.withConfig({
  displayName: "HeaderOffsetContainer",
  componentId: "r1b9cw-0"
})(["padding-top:", ";", ";", ";", ""], function (_ref) {
  var theme = _ref.theme;
  return rem(_get(theme, 'header.height', headerTheme.header.height));
}, function (_ref2) {
  var bgStart = _ref2.bgStart;
  return bgStart && css(["background-color:", ";"], bgStart);
}, function (_ref3) {
  var bgStart = _ref3.bgStart,
      bgEnd = _ref3.bgEnd;
  return bgStart && bgEnd && css(["background-image:linear-gradient(to bottom,", " 0,", " 100%);"], bgStart, bgEnd);
}, function (_ref4) {
  var isFullHeight = _ref4.isFullHeight;
  return isFullHeight && css(["height:100vh;"]);
});
export default HeaderOffsetContainer;